import './styles.scss';
import { FormattedMessage } from 'react-intl';

export interface ClearButtonProps {
  onClick: () => void;
}

export const ClearButton = ({ onClick }: ClearButtonProps): JSX.Element => (
  <button className="clearButton" onClick={onClick}>
    <FormattedMessage id="clear-button" defaultMessage="Azzera Ricerca" />
  </button>
);
